












import Vue from 'vue';
import Page from '@/components/Page.vue';
import GrievanceItemHeader from '../components/grievance/item/GrievanceItemHeader.vue';
import GrievanceItemActions from '../components/grievance/item/GrievanceItemActions.vue';
import FollowUpList from '../components/grievance/item/follow_up/FollowUpList.vue';
import { createNamespacedHelpers } from 'vuex';
import _ from 'lodash';
import { FollowUp } from '@/store/types';
const { mapState, mapActions } = createNamespacedHelpers('grievanceItem');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: {
        FollowUpList,
        GrievanceItemActions,
        GrievanceItemHeader,
        Page,
    },
    computed: {
        ...mapCustomLabelsState(['portalTitle', 'instanceTitle']),
        ...mapState([
            'followUps',
            'portalAccessToken',
            'description',
            'documents',
            'anonymous',
            'firstName',
            'lastName',
            'date',
        ]),
        author(): string {
            if (this.anonymous) {
                return this.$t('anonymous') as string;
            }
            return `${this.firstName} ${this.lastName}`;
        },
        followUpList(): FollowUp[] {
            return this.followUps.concat({
                id: 0,
                author: this.author,
                date: this.date,
                description: this.description,
                documents: this.documents,
                original: true,
            });
        },
        lastFollowUp(): FollowUp | undefined {
            return _.first(this.followUpList);
        },
    },
    watch: {
        '$route.hash': function() {
            const selectedId = _.parseInt(_.last(_.split(this.$route.hash, '#')) || '');
            const followUpIds = _.map(this.followUpList, followUp => +followUp.id);
            if (!_.includes(followUpIds, selectedId)) {
                this.selectLast();
            }
        },
    },
    async beforeRouteEnter(to, from, next) {
        const store = require('@/store').default;
        await store.dispatch('grievanceItem/fetchData');
        next();
    },
    created() {
        const refNo = this.$route.params.refNo;
        const portalTitle = this.portalTitle;
        const instanceTitle = this.instanceTitle;
        document.title = `${instanceTitle} | ${refNo} | ${portalTitle}`;
    },
    mounted() {
        const refNo = this.$route.params.refNo;
        if (this.$route.name !== 'FollowUpPage') {
            this.$router.replace(`/${this.$route.params.instanceId}/grievance/${refNo}/follow_up`);
        }
    },
    methods: {
        ...mapActions(['fetchData']),
        scrollTo(followUpId: string) {
            document.getElementById(followUpId)?.scrollIntoView();
        },
        scrollToOriginal() {
            this.scrollTo(this.selectOriginal());
        },
        selectLast() {
            window.location.hash = `#${this.lastFollowUp?.id ?? '0'}`;
        },
        selectOriginal(): string {
            window.location.hash = `#0`;
            return '0';
        },
    },
});
